<div class="sidenav boxs" id="mySidenav">
  <a class="navbar-brand" (click)="goToLandingPage()">
    <img src="https://cdn-dev.obsidiam.com/img/logos/obsidiam_logo_full_white.png"
      srcset="https://cdn-dev.obsidiam.com/img/logos/obsidiam_logo_full_white@2x.png 2x,
              https://cdn-dev.obsidiam.com/img/logos/obsidiam_logo_full_white@3x.png 3x" alt="Obsidiam">
  </a>
  <div class="boxs">
    <a *ngIf="url=='login'" [routerLink]="['/subscribe']">{{'signUp.signUp'|translate}}</a>
    <a *ngIf="url=='subscribe' || url=='forgot-password' || url=='verify'" [routerLink]="['/login']">{{'login.login'|translate}}</a>
  </div>

</div>